import axiosBasicInstance from '../axiosConfig';


const getListNotification = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/notification/list-notification`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateNotification = async (data, userId, role, companyId) => {
   try {
      const response = await axiosBasicInstance.post(`/management/notification/sync/${companyId}/${userId}/${role}`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const listUserAdmin = async (companyId) => {
   try {
      const response = await axiosBasicInstance.get(`/management/notification/save/${companyId}/userId`);
      return response;
   } catch (error) {
      throw error;
   }
};


export { getListNotification, updateNotification, listUserAdmin};
